// extracted by mini-css-extract-plugin
export default {"container":"LabelAndDivider_container__XDOHE","labelText":"LabelAndDivider_labelText__-Nl29"};